import { Outlet } from 'react-router-dom'

import { Header } from '../../components/Header'
import { Footer } from '../../components/Footer'
import { FooterVisibilityProvider } from '../../context/FooterVisibilityContext'
import { Social } from '../../components/Social'

export function AppLayout() {
 return (
  <>
   <Header />
   <main>
    <Outlet />
   </main>
   <FooterVisibilityProvider>
    <Footer />
    <Social />
   </FooterVisibilityProvider>
  </>
 )
}
